<template>
  <b-container>
    <b-card no-body>
      <b-card-header>
        <b-card-title>
          Unitwizard
          <i class="fa fa-magic" />
        </b-card-title>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col>
            <b-card-body>
              <b-tabs v-model="tab">
                <b-tab title="Selecteer een bestaand complex">
                  <b-form-group label="Zoeken">
                    <b-input-group>
                      <b-input
                        v-model="zoekterm"
                        type="search"
                        debounce="200"
                        placeholder="Complexnummer"
                      />
                      <b-input-group-text>Beginnend met een</b-input-group-text>
                      <b-input-group-addon>
                        <b-radio-group
                          v-model="groep"
                          :options="['T', 'D', 'C']"
                          buttons
                        />
                      </b-input-group-addon>
                    </b-input-group>
                  </b-form-group>

                  <b-alert 
                    :show="filterComplexen.length > 100" 
                    variant="info"
                  >
                    Meer dan 100 resultaten... Verfijn de zoekterm.
                  </b-alert>

                  <b-table
                    v-if="complexen && filterComplexen.length < 100"
                    ref="complexTable"
                    :items="filterComplexen"
                    :fields="['Nr', 'Re', 'Qu']"
                    selectable
                    select-mode="single"
                    bordered
                    hover
                    @row-selected="rowSelected"
                  >
                    <template #cell(Nr)="row">
                      {{ row.item.Nr }}
                    </template>
                  </b-table>
                </b-tab>
                <b-tab title="Nieuw complex">
                  <b-form-group label="Afbeelding">
                    <b-form-file
                      v-model="nieuwcomplex.thumb"
                      accept=".jpg, .png"
                      placeholder="Kies een afbeelding voor het complex"
                      drop-placeholder="Laat maar los"
                    />
                  </b-form-group>
                  <b-form-group
                    label="Complex"
                    description="Staat de relatie er nog niet bij? Maak deze dan eerst aan onder relaties"
                  >
                    <b-input-group>
                      <b-input-group-prepend 
                        is-text
                      >
                        {{ groep
                        }}{{
                          nieuwcomplex.relatie
                            ? nieuwcomplex.relatie.adviesnummer
                            : "?"
                        }}-
                      </b-input-group-prepend>
                      <b-input
                        v-model="nieuwcomplex.nummer"
                        type="text"
                        placeholder="Nummer"
                      />
                      <b-select
                        v-model="nieuwcomplex.relatie"
                        :options="relatieOpties"
                        :state="nieuwcomplex.relatie != null"
                        text-field="label"
                        value-field="value"
                        placeholder="Kies een relatie"
                      >
                        <template #first>
                          <b-form-select-option 
                            :value="null" 
                            disabled
                          >
                            -- Kies een relatie --
                          </b-form-select-option>
                        </template>
                      </b-select>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group label="Huismeester">
                    <b-input-group>
                      <b-input
                        v-model="nieuwcomplex.huismeester.naam"
                        type="text"
                        placeholder="Naam"
                      />
                      <b-input
                        v-model="nieuwcomplex.huismeester.telefoonnummer"
                        type="text"
                        placeholder="Telefoonnummer"
                      />
                    </b-input-group>
                  </b-form-group>
                </b-tab>
              </b-tabs>
            </b-card-body>
          </b-col>
          <b-col>
            <b-card v-if="tab > 0 && nieuwcomplex.relatie">
              <b-card-title>
                <b-badge variant="info">
                  Nieuw complex
                </b-badge>
                Complex {{ groep
                }}{{ nieuwcomplex.relatie.adviesnummer }}-{{
                  nieuwcomplex.nummer
                }}
              </b-card-title>
              <b-img
                :src="
                  hasImage
                    ? imageSrc
                    : 'https://res.cloudinary.com/transplan/image/upload/v1598353187/no-img_tumjza.jpg'
                "
                width="100"
                height="100"
                style="object-fit: cover"
              />
              {{ nieuwcomplex.relatie ? nieuwcomplex.relatie.naam : "-" }}
            </b-card>
            <b-card 
              v-if="complex" 
              :title="'Complex ' + complexnummer"
            >
              <b-img
                :src="
                  complex.Th == '/img/no-img.jpg'
                    ? 'https://res.cloudinary.com/transplan/image/upload/v1598353187/no-img_tumjza.jpg'
                    : complex.Th
                "
                width="100"
              />
              <b-card-text />
            </b-card>
            <b-form-group 
              label="Type" 
              description="Het type van de unit"
            >
              <b-form-radio-group
                v-model="type"
                :state="type != null"
                :options="['LT', 'LH', 'RT', 'GE', 'PL', 'DE', 'TA']"
                buttons
              />
            </b-form-group>
            <b-form-group 
              label="Titel" 
              description=""
            >
              <b-input
                v-model="basis.titel"
                :state="basis.titel != null"
                type="text"
              />
            </b-form-group>
            <b-form-group 
              label="Adres" 
              description=""
            >
              <b-input
                v-model="basis.adres"
                :state="basis.adres != null"
                type="text"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer>
        <b-button
          :disabled="!kanAangemaaktWorden"
          variant="success"
          class="pull-right"
          @click="createUnitComplex()"
        >
          Aanmaken
          <span v-if="tab == 1">complex en</span> {{ type }} unit
        </b-button>
      </b-card-footer>
    </b-card>
  </b-container>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";

const base64Encode = (data) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export default {
  mixins: [serviceMixin],
  data() {
    return {
      tab: 0,
      complexen: [],
      relaties: [],
      groep: "D",
      file: null,
      zoekterm: "",
      complex: null,
      nieuwcomplex: {
        thumb: null,
        nummer: "",
        relatie: null,
        huismeester: {
          naam: "",
          telefoonnummer: "",
        },
      },
      type: "LT",
      error: null,
      basis: {
        titel: null,
        adres: null,
        keuringsstatus: -2,
      },
      imageSrc: null,
    };
  },
  computed: {
    hasImage() {
      return !!this.nieuwcomplex.thumb;
    },
    complexnummer: function () {
      if (this.isNieuwComplex) {
        return `${this.groep}${
          this.nieuwcomplex.relatie
            ? this.nieuwcomplex.relatie.adviesnummer
            : "?"
        }-${this.nieuwcomplex.nummer}`;
      } else {
        return this.complex.Nr;
      }
    },
    isNieuwComplex() {
      return this.tab > 0;
    },
    kanAangemaaktWorden() {
      if (this.type == null) return false;
      if (
        (this.isNieuwComplex && !this.nieuwcomplex.relatie) ||
        (!this.isNieuwComplex && !this.complex)
      )
        return false;
      if (!this.basis.titel) return false;
      if (!this.basis.adres) return false;
      return true;
    },
    relatieOpties: function () {
      return this.relaties.map(function (item) {
        return {
          label: item.Naam,
          value: {
            adviesnummer: item.Adviesnummer,
            id: item.Id,
            naam: item.Naam,
          },
        };
      });
    },
    filterComplexen: function () {
      return this.complexen.filter(
        (item) => item.Nr.toLowerCase().search(this.zoekterm.toLowerCase()) > -1
      );
    },
  },
  watch: {
    tab: function () {
      if (this.$refs.complexTable) this.$refs.complexTable.clearSelected();
      this.complex = null;
      if (this.relaties.length == 0) this.getRelaties();
    },
    groep: function () {
      this.getComplexen();
    },
    "nieuwcomplex.thumb": function (newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then((value) => {
              this.imageSrc = value;
            })
            .catch(() => {
              this.imageSrc = null;
            });
        } else {
          this.imageSrc = null;
        }
      }
    },
  },
  mounted() {
    this.getComplexen();
  },
  methods: {
    getRelaties() {
      var vm = this;
      this.get("/relaties")
        .then(function (response) {
          console.log(response);
          vm.relaties = response.data.relaties;
        })
        .catch(function (error) {
          vm.error = error;
        });
    },
    rowSelected(record) {
      console.log(record);
      this.complex = record[0];
    },
    createUnitComplex() {
      var vm = this;
      var formdata = new FormData();
      formdata.append("nieuwcomplex", this.tab > 0);
      formdata.append(
        "complex",
        this.tab > 0
          ? JSON.stringify(this.nieuwcomplex)
          : JSON.stringify(this.complex)
      );
      formdata.append("unit", JSON.stringify(this.basis));
      formdata.append("type", this.type);

      // foto alleen meesturen bij een nieuwcomplex
      if (this.isNieuwComplex) formdata.append("file", this.nieuwcomplex.thumb);

      this.postMultipart("/complexen/" + this.groep, formdata).then(function (
        response
      ) {
        console.log(response.data);
        vm.$router.push({ path: response.data.redirect });
      });
    },
    getComplexen() {
      var vm = this;
      this.get("/complexen/" + this.groep)
        .then(function (response) {
          console.log(response);
          vm.complexen = response.data.complexen;
        })
        .catch(function (error) {
          vm.error = error;
        });
    },
  },
};
</script>